import { render, staticRenderFns } from "./ResultItem.vue?vue&type=template&id=ec0d2b14&scoped=true&"
import script from "./ResultItem.vue?vue&type=script&lang=js&"
export * from "./ResultItem.vue?vue&type=script&lang=js&"
import style0 from "./ResultItem.vue?vue&type=style&index=0&id=ec0d2b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0d2b14",
  null
  
)

export default component.exports